import React from 'react'
import PropTypes from 'prop-types'

FilterInput.propTypes = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired
}

function FilterInput(props) {
    const {label, placeholder, value, name, onChangeInput} = props

    return (
        <div className="FilterInput">
            <label htmlFor={label}>{label}</label>
            <input type="text" id={label} name={name} value={value} placeholder={placeholder} onChange={onChangeInput}/>
        </div>
    )
}

export default FilterInput
